/**
 * Auth Controller
 * Orchestrates sign-in, sign-out, and session access.
 */

import { getPublicConfig } from "../../excel/config/getPublicConfig";
import { authStore } from "./authStore";
import { openAuthDialog } from "./dialogAuth";
import { getSignInDialogUrl } from "./signInCoordinator";
import type { AuthSession } from "./types";

export async function signIn(mode: "oauth" | "otp" = "oauth"): Promise<AuthSession> {
  const { url } = await getSignInDialogUrl(mode);
  const session = await openAuthDialog(url);
  await authStore.save(session);
  return session;
}

export async function signOut(): Promise<void> {
  try {
    const config = await getPublicConfig();
    const baseUrl = config.public.apiBaseUrl.replace(/\/$/, "");
    await fetch(baseUrl + "/v1/auth/signout", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({}),
    });
  } catch {
    // Best-effort; ignore failures
  }
  await authStore.clear();
}

export async function getSession(): Promise<AuthSession | null> {
  return authStore.load();
}
